import React from 'react';
import LazyLoader from './LazyLoader';

const DataLoader = ({ isLoading, children, fallback = null }) => {
  if (isLoading) {
    return <LazyLoader />;
  }
  
  return children || fallback;
};

export default DataLoader;